/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainProfileType = 'SuperAdministrator' | 'Staff' | 'Parent' | 'Student' | 'Visitor';

export const DomainProfileType = {
    SuperAdministrator: 'SuperAdministrator' as DomainProfileType,
    Staff: 'Staff' as DomainProfileType,
    Parent: 'Parent' as DomainProfileType,
    Student: 'Student' as DomainProfileType,
    Visitor: 'Visitor' as DomainProfileType
};